export enum AdminUserType {
  All = "All User Types",
  Households = "Household",
  Provider = "Provider",
  Schools = "School",
  Admin = "Admin"
}

export const PartnerTypeIdToUserType: Record<number, AdminUserType> = {
  0: AdminUserType.All,
  1: AdminUserType.Schools,
  2: AdminUserType.Provider,
  3: AdminUserType.Households
};

export enum UserRecordType {
  Comments = 'comments',
  Contacts = 'contacts',
  Documents = 'documents',
  Emails = 'emails',
  Employees = 'employees',
  IncomeVerification = 'incomeVerification',
  IssueTracking = 'tracks',
  PaymentInformation = 'paymentInformation',
  Messages = 'messages',
  Students = 'students',
  Tasks = 'tasks'
}